let state = {
    user: {},
    sidebarShow: 'responsive',
    sidebarMinimize: false,
}
export default state
